import { HsaReimbursementAccountType } from "@redotech/cockroachdb-codegen/tables/conversion/hsa-reimbursement-account-type";
import {
  hsaReimbursementDetails,
  hsaReimbursementFieldSpec,
} from "@redotech/redo-conversion-hsa-common/reimbursement/hsa-reimbursement-fields";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

/**
 * The shopper's one reimbursement profile, keyed by the order's Shopify
 * customer. `fields` never carries the SSN, in whole or in part; a form that
 * asks for it collects it again on every claim. `signatureOnFile` says whether
 * a stored signature can back a repeat claim.
 */
export const getHsaReimbursementProfile = {
  name: "getHsaReimbursementProfile" as const,
  input: z.object({ orderId: zExt.objectId() }),
  output: z.object({
    profile: z
      .object({
        provider: z.string(),
        accountType: createEnum(HsaReimbursementAccountType),
        fields: hsaReimbursementDetails,
        fieldSpecs: z.array(hsaReimbursementFieldSpec),
        signatureOnFile: z.boolean(),
      })
      .nullable(),
  }),
};
